import React, { useEffect, useState } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer, toast } from "react-toastify";
import { Buffer } from "buffer";
import AWS from "aws-sdk";
import * as Icon from "react-feather";
import { backendApi, backendApiS3Credential } from "../../api/apiService";
import { FaCamera, FaTrash } from "react-icons/fa";
import Avatar from "react-avatar-edit";
import defaultImg from "../../images/defaultImg.png";
import { useNavigate } from "react-router-dom";
import { awsConfig } from "../../config";
const S3BucketImagesFolder = "images";
var s3Region;
var s3bucketAccessKey;
var s3bucketSecretKey;
var s3Bucket;
var bucketParams;
var s3;
export default function Profile() {
  const navigate = useNavigate();
  const [userDetaisData, setUserDetaisData] = useState([]);
  const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);
  const [imagecrop, setimagecrop] = useState(false);
  const [pview, setpview] = useState(false);
  const [profile, setprofile] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [hasDp, setHasDp] = useState(false);
  const [mainName, setMainName] = useState();
  const [mainNameLast, setMainNameLast] = useState();
  useEffect(() => {
    getUserDetails();
    getS3Credentials();
  }, []);
  const getUserDetails = () => {
    const apiSave = {
      functionName: "getUserDetails",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
    };
    backendApi(apiSave).then((data) => {
      if (data.success === "1") {
        setUserDetaisData(data?.stage[0]);
        setMainName(data?.stage[0]?.first_name);
        setMainNameLast(data?.stage[0]?.last_name);
      } else {
        return;
      }
    });
  };
  const getS3Credentials = () => {
    // const credentialReq = {
    //   functionName: "s3Credentials",
    // };
    // backendApiS3Credential(credentialReq).then((data) => {
    //   s3Region = "ap-south-1";
    //   s3bucketAccessKey = data.data[0].s3bucketAccessKey;
    //   s3bucketSecretKey = data.data[0].s3bucketSecretKey;
    //   s3Bucket = "bugiffy-prod";
    //   bucketParams = {
    //     Bucket: s3Bucket,
    //   };
    //   AWS.config.update({
    //     accessKeyId: s3bucketAccessKey,
    //     secretAccessKey: s3bucketSecretKey,
    //     region: s3Region,
    //   });
    //   s3 = new AWS.S3({
    //     apiVersion: "2006-03-01",
    //     params: bucketParams,
    //   });
    // });
    const bucketParams = {
      Bucket: awsConfigDataState.s3Bucket,
    };
    AWS.config.update({
      accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
      region: "us-east-1",
    });
    s3 = new AWS.S3({
      apiVersion: "2006-03-01",
      params: bucketParams,
    });
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setUserDetaisData((prevUserDetails) => ({
      ...prevUserDetails,
      [name]: value,
    }));
  };
  const saveDetails = () => {
    var flag = true;
    if (!userDetaisData.first_name) {
      toast.warn("First Name Required", { containerId: "F" });
      document.getElementById("first_name").focus();
      flag = false;
    } else if (!userDetaisData.last_name) {
      toast.warn("Last Name Required", { containerId: "F" });
      document.getElementById("last_name").focus();
      flag = false;
    } else if (!userDetaisData.email_id) {
      toast.warn("Email Id Required", { containerId: "F" });
      document.getElementById("email_id").focus();
      flag = false;
    } else if (
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(
        userDetaisData.email_id
      )
    ) {
      toast.warn("Invalid Email Address", { containerId: "F" });
      document.getElementById("email_id").focus();
      flag = false;
    } else if (!userDetaisData.mobile_no) {
      toast.warn("Phone Number Required", { containerId: "F" });
      document.getElementById("mobile_no").focus();
      flag = false;
    } else if (!/^[0-9]/.test(userDetaisData.mobile_no)) {
      toast.warn("Invalid Phone Number", { containerId: "F" });
      document.getElementById("mobile_no").focus();
      flag = false;
    }
    // else if(!userDetaisData.profile_image_url)
    // {
    //   toast.warn("Profile Picture Requred Required", { containerId: "F" })
    //   // document.getElementById('mobile_no').focus();
    //   flag=false
    // }
    if (flag === true) {
      const req = {
        functionName: "updateUserDetails",
        site_id: localStorage.getItem("siteId"),
        sec_user_id: localStorage.getItem("userId"),
        first_name: userDetaisData?.first_name,
        last_name: userDetaisData?.last_name,
        email_id: userDetaisData?.email_id.trim(),
        mobile_no: userDetaisData?.mobile_no.trim(),
        profile_image_url: userDetaisData?.profile_image_url,
      };
      backendApi(req).then((data) => {
        if (data.success === "1") {
          setUserDetaisData(data?.stage[0]);
          getUserDetails();
          toast.success("Your Changes Saved Successfully ", {
            containerId: "F",
          });
        } else {
          toast.warn("Something went wrong", { containerId: "F" });
          getUserDetails();
        }
      });
    }
  };
  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };
  const onCrop = (view) => {
    if (view) {
      setpview(view);
    }
  };
  const onClose = () => {
    setpview(null);
  };
  const saveCropImage = () => {
    if (pview) {
      handleImageUpload();
      setprofile([...profile, { pview }]);
      setimagecrop(false);
    } else {
      toast.warn("Please select an image", { containerId: "A" });
    }
  };
  const handleImageUpload = async (files) => {
    const webpBuffer = convertBase64ToBuffer(pview, "webp");
    const fileName = uuidv4();
    const fullFilePath = S3BucketImagesFolder + "/" + fileName + ".webp";
    try {
      const data = await s3
        .upload({
          Key: fullFilePath,
          Body: webpBuffer,
          ACL: "public-read",
          ContentType: "image/webp",
        })
        .promise();
      setUserDetaisData((prevUserDetails) => ({
        ...prevUserDetails,
        ["profile_image_url"]: data.Location,
      }));
    } catch (err) {
      console.error("Error occurred during image upload", err);
      return;
    }
  };
  const convertBase64ToBuffer = (base64Url, format = "webp") => {
    const base64Data = base64Url.split(",")[1];
    const buffer = Buffer.from(base64Data, "base64");
    return buffer;
  };
  const removePic = () => {
    // const formattedFirstName =
    //   firstName.charAt(0).toUpperCase() + firstName.slice(1);
    // const formattedLastName =
    //   lastName.charAt(0).toUpperCase() + lastName.slice(1);
    var request = {
      functionName: "pofileUpdate",
      // id: user_id,
      // first_name: formattedFirstName,
      // last_name: formattedLastName,
      // address: address,
      // mobile_no: phone,
      // designation: designation,
      // profileImage: "",
    };
    backendApi(request).then((response) => {
      if (response?.success === "1") {
        toast.success("Profile Picture Removed", { containerId: "A" });
        setIsDropdownVisible(false);
      } else {
        toast.error(response.errorMessage, { containerId: "A" });
      }
    });
  };
  const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const CancelClick = () => {
    getUserDetails();
  };
  const handleImageError = (event) => {
    // If the image fails to load, set the source to the default image
    event.target.src = defaultImg;
  };
  const goBack = () => {
    navigate(-1);
  };
  const [menuClick, setMenuClick] = useState(false)
  const toggleMenu = () => {
    setMenuClick(!menuClick)
  }
  const closeMenu = () => {
    setMenuClick(false)
  }
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"F"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header Header="Profile" toggleMenu={toggleMenu} menuClick={menuClick} />
          <div className="main-container">
            <div className="xilliRight">
              <div className="xilliWrap">
                {/* <div className="xilliBrudcrb">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <h1>Profile</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="card main-card">
                  <div className="card-body">
                <div className="col-md-12">
                  <div
                    className="row xilliFirst "
                    style={{ background: "transparent", padding: "0px" }}
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <div className="xilliBrudcrb">
                          {/* <h1 className="xiUpIntr">Upcoming Interviews</h1> */}
                          <div className="crmPro">
                            <div className="xiUser">
                              <div className="profile-crop-image">
                                {/* ========================== */}
                                <div
                                  className="profile-pic crop-image "
                                  onClick={() => {
                                    setimagecrop(true);
                                  }}
                                >
                                  {hasDp && (
                                    <label className="-label" for="file">
                                      <FaCamera
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault(); // Prevent default file input dialog
                                          toggleDropdown();
                                        }}
                                      />
                                    </label>
                                  )}
                                  <img
                                    onError={handleImageError}
                                    src={
                                      userDetaisData?.profile_image_url
                                        ? userDetaisData?.profile_image_url
                                        : defaultImg
                                    }
                                    id="output"
                                    width="200"
                                    alt="profile-img"
                                  />
                                </div>
                                <label htmlFor="" className="profile-img-name">
                                  {/* {firstName ? firstName : email} */}
                                </label>
                                {imagecrop && (
                                  <div
                                    className="module_popup addPeople"
                                    id="addsprint"
                                  >
                                    <div className="module_innerpopup module_bodypop">
                                      <div className="module_headdiv">
                                        <h4 className="popup_head">
                                          {" "}
                                          Upload Profile Picture
                                        </h4>
                                        <div className="module_close">
                                          <Icon.X
                                            color="grey"
                                            onClick={() => {
                                              setimagecrop(false);
                                            }}
                                            size={18}
                                          />
                                        </div>
                                      </div>
                                      <div style={{ width: "100%" }}>
                                        <Avatar
                                          width={"100%"}
                                          height={300}
                                          onCrop={onCrop}
                                          onClose={onClose}
                                          label={
                                            <span className="click_upload">
                                              Click here to Upload
                                            </span> 
                                          }
                                          // src={src}
                                          shadingColor={"#474649"}
                                          backgroundColor={"#474649"}
                                          style={{ color: "blue" }}
                                        />
                                      </div>
                                      <div className="button-wrapper mt-2">
                                        <button
                                          className="btn-save"
                                          onClick={saveCropImage}
                                          label="Save"
                                        >
                                          Crop
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {isDropdownVisible && (
                                  <>
                                    <div
                                      className="removePic"
                                      onClick={removePic}
                                    >
                                      <p>
                                        <FaTrash color="red" /> &nbsp;Remove
                                        Photo
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                              <h2 className="main-head">{mainName}</h2>
                              {/* <h6>Frontend Developer</h6> */}
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label htmlFor="" className="form-label">
                                    First Name
                                    <span className="red ml-1">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    onChange={handleChange}
                                    name="first_name"
                                    id="first_name"
                                    className="form-control"
                                    placeholder="First Name"
                                    value={userDetaisData?.first_name}
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label htmlFor="" className="form-label">
                                    Last Name<span className="red ml-1">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Last Name"
                                    name="last_name"
                                    id="last_name"
                                    value={userDetaisData?.last_name}
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label htmlFor="" className="form-label">
                                    Email Id<span className="red ml-1">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Email Id"
                                    name="email_id"
                                    id="email_id"
                                    value={userDetaisData?.email_id}
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label htmlFor="" className="form-label">
                                    Phone Number
                                    <span className="red ml-1">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Phone Number"
                                    name="mobile_no"
                                    id="mobile_no"
                                    maxLength={12}
                                    value={userDetaisData?.mobile_no}
                                  />
                                </div>
                              </div>
                              {/* <div className="col-md-4">
                                <div className="form-group">
                                  <label htmlFor="">
                                    Address<span className="red ml-1">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Address"
                                  // name="first_name"
                                  // id="first_name"
                                  // value={userDetaisData?.last_name}
                                  />
                                </div>
                              </div> */}
                              {/* <div className="col-md-4">
                                <div className="form-group">
                                  <label htmlFor="">
                                    Designation
                                    <span className="red ml-1">*</span>{" "}
                                  </label>
                                  <input
                                    type="text"
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Designation"
                                  // value={userDetaisData?.last_name}
                                  />
                                </div>
                              </div> */}
                            </div>
                            <div className="childIssueses my-2">
                              <button
                                className="btn-btn btn btn-btn2 btn-sm me-2"
                                onClick={() => saveDetails()}
                              >
                                Save
                              </button>
                              <button
                                className="btn-btn btn btn-btn1 btn-sm"
                                onClick={goBack}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
